import React from 'react';
import { Lock, ArrowRight } from 'lucide-react';
interface LandingScreenProps {
  onStart: () => void;
}
export const LandingScreen: React.FC<LandingScreenProps> = ({
  onStart
}) => {
  return <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 bg-cream font-sans text-dark-text" data-id="element-7">
      <div className="max-w-[640px] w-full flex flex-col items-center text-center" data-id="element-8">
        {/* Eyebrow */}
        <p className="text-[11px] md:text-xs font-bold tracking-[0.15em] text-forest-green uppercase mb-6" data-id="element-9">
          Diagnóstico Hormonal Personalizado
        </p>

        {/* Headline */}
        <h1 className="font-serif text-[2.5rem] md:text-[3.25rem] leading-[1.15] font-bold text-dark-text mb-6" data-id="element-10">
          Responde 6 preguntas y descubre{' '}
          <span className="text-forest-green" data-id="element-11">
            exactamente por qué tus hormonas dejaron de funcionar
          </span>{' '}
          — y qué hacer para reactivarlas en 7 días
        </h1>

        {/* Subtitle */}
        <p className="text-[#555555] text-[1.05rem] md:text-[1.15rem] leading-relaxed max-w-[90%] mb-10" data-id="element-12">
          Sin terapia hormonal. Sin suplementos. Sin salir de tu casa. Solo la
          señal que tu cuerpo ha estado esperando.
        </p>

        {/* Benefits List */}
        <div className="flex flex-col gap-4 w-full max-w-[480px] text-left mb-10" data-id="element-13">
          {['Identifica qué está bloqueando tu señal hormonal', 'Recibe tu diagnóstico personalizado al instante', 'Descubre el protocolo que lo reactiva en 7 días'].map((text, index) => <div key={index} className="flex items-start gap-4" data-id="element-14">
              <div className="w-6 h-6 rounded-full bg-mint-green text-forest-green flex items-center justify-center text-xs font-bold shrink-0 mt-0.5" data-id="element-15">
                {index + 1}
              </div>
              <p className="text-[0.95rem] md:text-base text-[#333333] leading-snug" data-id="element-16">
                {text}
              </p>
            </div>)}
        </div>

        {/* CTA Button */}
        <button onClick={onStart} className="w-full max-w-[480px] bg-forest-green text-white py-4 px-6 rounded-lg font-semibold text-[1.1rem] flex items-center justify-center gap-2 hover:bg-[#0f4430] transition-colors shadow-[0_4px_14px_0_rgba(20,88,62,0.25)]" data-id="element-17">
          Comenzar Diagnóstico Gratis <ArrowRight className="w-5 h-5" data-id="element-18" />
        </button>

        {/* Lock Text */}
        <div className="flex items-center justify-center gap-1.5 mt-4 text-[0.75rem] text-[#888888] max-w-[480px]" data-id="element-19">
          <Lock className="w-3 h-3 shrink-0" data-id="element-20" />
          <p data-id="element-21">
            Sin email. Sin teléfono. Solo tu nombre al final para personalizar
            tu reporte. Esta información no sale de esta página.
          </p>
        </div>
      </div>

      {/* Footer Disclaimer */}
      <div className="mt-auto pt-16 pb-4 max-w-[800px] text-center" data-id="element-22">
        <p className="text-[0.65rem] text-[#AAAAAA] leading-relaxed" data-id="element-23">
          Este sitio no forma parte del sitio web de Facebook ni está respaldado
          por Meta Platforms, Inc. de ninguna manera. FACEBOOK es una marca
          registrada de Meta Platforms, Inc.
        </p>
      </div>
    </div>;
};